module.exports = __webpack_public_path__ + "img/fgr-2.d0029977.svg";